export default __webpack_public_path__ + "static/media/t3.8017b41f.jpg";